module.exports = __webpack_public_path__ + "img/arrow-down-black.958c7260.svg";